export enum BusinessBankAccountDepositTypes {
  PAYMAYA = 1,
  BANK = 2,
  NO_ACCOUNT = 3,
  GCASH = 4,
}

export enum BusinessBankAccountTypes {
  SAVINGS = 1,
  CHECKING_CURRENT = 2,
}

export enum BankList {
  AL_AMANAH_ISLAMIC_BANK = 'AL_AMANAH_ISLAMIC_BANK',
  ANZ_BANK = 'ANZ_BANK',
  ASIA_UNITED_BANK = 'ASIA_UNITED_BANK',
  BANGKOK_BANK = 'BANGKOK_BANK',
  BANK_OF_AMERICA_NA = 'BANK_OF_AMERICA_NA',
  BANK_OF_CHINA_MANILA = 'BANK_OF_CHINA_MANILA',
  BANK_OF_COMMERCE = 'BANK_OF_COMMERCE',
  BANK_OF_THE_PHILIPPINE_ISLANDS_BPI = 'BANK_OF_THE_PHILIPPINE_ISLANDS_BPI',
  BDO_NETWORK_BANK = 'BDO_NETWORK_BANK',
  BDO_UNIBANK = 'BDO_UNIBANK',
  CHINA_BANK = 'CHINA_BANK',
  CHINA_BANK_SAVINGS = 'CHINA_BANK_SAVINGS',
  CITIBANK_NA = 'CITIBANK_NA',
  CIMB = 'CIMB',
  CTBC_BANK = 'CTBC_BANK',
  DEUTSCHE_BANK = 'DEUTSCHE_BANK',
  DEVELOPMENT_BANK_OF_THE_PHILIPPINES_DBP = 'DEVELOPMENT_BANK_OF_THE_PHILIPPINES_DBP',
  DUNGGANUN_BANK = 'DUNGGANUN_BANK',
  EASTWEST_BANK = 'EASTWEST_BANK',
  EQUICOM_SAVINGS_BANK = 'EQUICOM_SAVINGS_BANK',
  FIRST_CONSOLIDATED_BANK = 'FIRST_CONSOLIDATED_BANK',
  GCASH = 'GCASH',
  GOTYME = 'GOTYME',
  HONG_KONG_AND_SHANGHAI_BANK_HSBC = 'HONG_KONG_AND_SHANGHAI_BANK_HSBC',
  INDUSTRIAL_BANK_OF_KOREA_MANILA = 'INDUSTRIAL_BANK_OF_KOREA_MANILA',
  ING_BANK = 'ING_BANK',
  JP_MORGAN_CHASE_BANK_MANILA = 'JP_MORGAN_CHASE_BANK_MANILA',
  KOREA_EXCHANGE_BANK = 'KOREA_EXCHANGE_BANK',
  LAND_BANK_OF_THE_PHILIPPINES = 'LAND_BANK_OF_THE_PHILIPPINES',
  MAYA_BANK = 'MAYA_BANK',
  MAYBANK_PHILIPPINES = 'MAYBANK_PHILIPPINES',
  MEGA_INTERNATIONAL_COMMERCIAL_BANK = 'MEGA_INTERNATIONAL_COMMERCIAL_BANK',
  METROPOLITAN_BANK_TRUST_CO_METROBANK = 'METROPOLITAN_BANK_TRUST_CO_METROBANK',
  MIZUHO_BANK = 'MIZUHO_BANK',
  MUFG_BANK = 'MUFG_BANK',
  PAYMAYA = 'PAYMAYA',
  PHILIPPINE_BANK_OF_COMMUNICATIONS_PBCOM = 'PHILIPPINE_BANK_OF_COMMUNICATIONS_PBCOM',
  PHILIPPINE_NATIONAL_BANK_PNB = 'PHILIPPINE_NATIONAL_BANK_PNB',
  PHILIPPINE_SAVINGS_BANK_PSBANK = 'PHILIPPINE_SAVINGS_BANK_PSBANK',
  PHILIPPINE_VETERANS_BANK = 'PHILIPPINE_VETERANS_BANK',
  PHILTRUST_BANK = 'PHILTRUST_BANK',
  PRODUCERS_SAVINGS_BANK_CORPORATION = 'PRODUCERS_SAVINGS_BANK_CORPORATION',
  RIZAL_COMMERCIAL_BANKING_CORP_RCBC = 'RIZAL_COMMERCIAL_BANKING_CORP_RCBC',
  ROBINSONS_BANK = 'ROBINSONS_BANK',
  SEABANK = 'SEABANK',
  SECURITY_BANK = 'SECURITY_BANK',
  SHINHAN_BANK = 'SHINHAN_BANK',
  STANDARD_CHARTERED_BANK = 'STANDARD_CHARTERED_BANK',
  STERLING_BANK_OF_ASIA = 'STERLING_BANK_OF_ASIA',
  SUMIMOTO_MITSUI_BANKING_CORP = 'SUMIMOTO_MITSUI_BANKING_CORP',
  TONG_YANG_SAVINGS_BANK = 'TONG_YANG_SAVINGS_BANK',
  UNION_BANK_OF_THE_PHILIPPINES = 'UNION_BANK_OF_THE_PHILIPPINES',
  UNITED_COCONUT_PLANTERS_BANK_UCPB = 'UNITED_COCONUT_PLANTERS_BANK_UCPB',
  UNITED_OVERSEAS_BANK_UOB = 'UNITED_OVERSEAS_BANK_UOB',
  WEALTH_DEVELOPMENT_BANK = 'WEALTH_DEVELOPMENT_BANK',
}
